import { mediaQuery } from '../enums/mediaQuery';
import useMediaQuery from './useMediaQuery';

export const useNotebook = () => {
  return useMediaQuery(mediaQuery.NOTEBOOK);
};
